import { get } from '@/lib/api/client'
import type { ApiResponse, Region } from '@/lib/api/types'

export class RegionService {
  /**
   * Get all regions (Public endpoint)
   * GET /regions/public/all
   */
  async getAllRegions(): Promise<ApiResponse<Region[]>> {
    return await get<ApiResponse<Region[]>>('regions/public/all')
  }
}

export const regionService = new RegionService()

